import theme from '../../../themes/green';

const styles = {
  wrapper: {
    width: '100%',
  },
  inputWrapper: {
    position: 'relative',
    width: '100%',
    margin: '20px 0',
  },
  error: {
    width: 40,
    height: 'calc(100% - 2px)',
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 2,
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+15,1+100 */
    background:
      'linear-gradient( 90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%)',
  },
  input: {
    fontSize: 11,
    position: 'relative',
    zIndex: 2,
    backgroundColor: 'transparent',
    borderWidth: 0,
    outline: 'none',
    width: '100%',
    padding: 10,
    borderBottom: '2px solid white',
    color: '#EEEEEE',
    transition: 'all 750ms cubic-bezier(0.230, 1.000, 0.320, 1.000)',
    ':hover': {
      borderWidth: 0,
      outline: 'none',
      borderBottom: `2px solid ${theme.pallete.color}`,
    },
    ':focus': {},
  },
  inputFocus: {
    borderWidth: 0,
    outline: 'none',
    color: 'black',
    borderBottom: `2px solid ${theme.pallete.color}`,
  },
  inputWithError: {
    borderBottom: '2px solid red',
    ':hover': {
      borderWidth: 0,
      borderBottom: '2px solid red',
    },
    ':focus': {
      borderWidth: 0,
      color: 'black',
      borderBottom: '2px solid red',
    },
  },
  background: {
    zIndex: 1,
    backgroundColor: '#ffffff',
    borderRadius: 2,
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
    transition: 'all 350ms cubic-bezier(0.230, 1.000, 0.320, 1.000)',
  },
  backgroundActive: {
    top: 0,
  },
  extra: {
    color: 'white',
    position: 'relative',
    top: -20,
  },
  accessory: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 3,
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'calc(100% - 2px)',
    margin: '0 10px',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/UIKit/Input/styles.js